import { CheckSVG, CopySVG } from '@sbercloud/uikit-product-icons';
import { BUTTON_SIZE } from '@snack-uikit/input-private';
import { jsx as _jsx } from "react/jsx-runtime";
export function getIcon(_ref) {
  var size = _ref.size,
    isChecked = _ref.isChecked;
  switch (size) {
    case BUTTON_SIZE.S:
      {
        return isChecked ? /*#__PURE__*/_jsx(CheckSVG, {
          size: 16
        }) : /*#__PURE__*/_jsx(CopySVG, {
          size: 16
        });
      }
    case BUTTON_SIZE.M:
    default:
      {
        return isChecked ? /*#__PURE__*/_jsx(CheckSVG, {
          size: 24
        }) : /*#__PURE__*/_jsx(CopySVG, {
          size: 24
        });
      }
  }
}